import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../../auth/SessionProvider.js';
import { PERMISSIONS } from '../../../shared/permissions.js';
import type { Permission } from '../../../shared/permissions.js';
import { classes } from '../../components/ui.js';

const TABS: { to: string; label: string; permission: Permission }[] = [
  { to: 'users', label: 'Users', permission: PERMISSIONS.ADMIN_USER_MANAGE },
  {
    to: 'task-orders',
    label: 'Task orders',
    permission: PERMISSIONS.ADMIN_TASK_ORDER_MANAGE,
  },
  { to: 'categories', label: 'Categories', permission: PERMISSIONS.ADMIN_CATEGORY_MANAGE },
  {
    to: 'approval-authority',
    label: 'Approval authority',
    permission: PERMISSIONS.ADMIN_MARKUP_CONFIGURE,
  },
  { to: 'reminders', label: 'Reminders', permission: PERMISSIONS.ADMIN_WORKFLOW_CONFIGURE },
];

/**
 * Administration shell. Every tab is configuration rather than code: task orders,
 * facilities, categories, markup, and users are all editable here so a new program
 * needs no deployment.
 */
export function AdminPage() {
  const { can } = useSession();
  const visibleTabs = TABS.filter((tab) => can(tab.permission));

  return (
    <div className="flex flex-col gap-5">
      <nav aria-label="Administration sections" className="border-b border-slate-200">
        <ul className="-mb-px flex flex-wrap gap-1">
          {visibleTabs.map((tab) => (
            <li key={tab.to}>
              <NavLink
                to={tab.to}
                className={({ isActive }) =>
                  classes(
                    'inline-block border-b-2 px-3 py-2 text-sm font-medium',
                    isActive
                      ? 'border-brand-700 text-brand-800'
                      : 'border-transparent text-slate-600 hover:border-slate-300 hover:text-slate-900',
                  )
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <Outlet />
    </div>
  );
}
